import React, { Component, ReactDOM } from "react";
import PropTypes from "prop-types";
import Recaptcha from "../../recaptcha/Recaptcha";

export const validation = {
  validateOn: ["blur"],
  validationRegex: /.{50,}/,
  required: true,
  message: {
    default: "Please verify you're not a robot"
  }
};

class RecaptchaConfigured extends Component {
  render() {
    const { sitekey } = this.props;
    return <Recaptcha validation={validation} sitekey={sitekey} />;
  }
}

RecaptchaConfigured.propTypes = {
  sitekey: PropTypes.string.isRequired
};

export default RecaptchaConfigured;
